export default theme => ({
  home: {
    height: '100%',
  }
})